// 服务端状态统一经 TanStack Query 管理；接口调用经 @qhub-cn/website-client 网站 SDK，页面不直接拼请求。
import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      // 业务变更不自动重试：受理情况不明时由用户或页面显式决定，不重复提交。
      mutations: { retry: false },
      queries: { retry: 1, staleTime: 10_000, refetchOnWindowFocus: false },
    },
  });
}
